import styled from 'styled-components';

import { Card } from '@calm-web/design-system';

export const OfferHasEndedWrapper = styled(Card)`
	padding: 48px;
`;
